function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import init from "./init";
import { ETRANSFER_CONFIG } from "./constants/config";
import Updater from "./hooks/Updater";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HOOK_ERROR_MESSAGE = 'Must call the provided initialization method`init` method before using hooks.';
var WebLoginContext = /*#__PURE__*/React.createContext({});
export default WebLoginContext;
export function useWebLoginContext() {
  var bridgeAPI = React.useContext(WebLoginContext);
  if (!bridgeAPI) {
    throw new Error(HOOK_ERROR_MESSAGE);
  }
  return bridgeAPI;
}
export var WebLoginProvider = function WebLoginProvider(_ref) {
  var children = _ref.children,
    bridgeAPI = _ref.bridgeAPI,
    config = _ref.config;
  var networkType = config.baseConfig.networkType || 'MAINNET';
  var _config = useMemo(function () {
    return _objectSpread(_objectSpread({}, ETRANSFER_CONFIG[networkType]), config);
  }, [config, networkType]);
  var finalBridgeAPI = useMemo(function () {
    return bridgeAPI || init(_config);
  }, [_config, bridgeAPI]);
  if (!finalBridgeAPI) {
    return null;
  }
  var getSignIn = finalBridgeAPI.getSignIn;
  return /*#__PURE__*/_jsxs(WebLoginContext.Provider, {
    value: finalBridgeAPI,
    children: [/*#__PURE__*/_jsx(Updater, {}), getSignIn(children)]
  });
};